import { useMutation } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import useRouter from '../../hooks/useRouter';
import { AppActionType, AppContextType } from '../../types/appContext.type';
import { LOGOUT } from '../profile/graphql/muatations';

const Signout = () => {
  const { dispatch } = useContext(AppContext) as AppContextType;
  const { navigate } = useRouter();
  const [logout, { loading, error, data }] = useMutation(LOGOUT, {
    onError() {},
  });

  useEffect(() => {
    logout();
  }, []);

  if (loading) return <LoaderComponent />;

  if (error) {
    if (error?.graphQLErrors?.length) {
      dispatch({ type: AppActionType.logout });
      navigate(ROUTES.LOGIN);
      return null;
    }
    navigate(-1);
    return null;
  }

  if (data) {
    dispatch({ type: AppActionType.logout });
    navigate(ROUTES.LOGIN);
    return null;
  }
  return null;
};

export default Signout;
